import axios from "axios";
import qs from "qs";
import { Message } from "element-ui";
import that from "../main";
import store from '../store/store.js';

const $axios = axios.create({
    baseURL: process.env.VUE_APP_HTTP_URL, //正式环境
    // baseURL: 'http://192.168.1.85:9020',
    // baseURL: 'http://192.168.1.89:9020',
    timeout: 300000,
    responseType: "json",
    headers: {
        "Content-Type": "application/json",
        'Accept-Language': store.state.language.language||'zh-CN'
    }
});

// 请求qs序列化
$axios.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem("token");
        if (
            config.method === "post" &&
            config.headers["Content-Type"] ===
                "application/x-www-form-urlencoded"
        ) {
            config.data = qs.stringify(config.data, {
                arrayFormat: "indices",
                allowDots: true
            });
        }
        if (token) {
            config.headers.token = token;
        }
        return config;
    },
    error => {
        Message({
            showClose: true,
            message: error && error.data.error_msg,
            type: "error"
        });
        return Promise.reject(error.data.error_msg);
    }
);

// 接收数据，刷新token，封装res.bus_json
$axios.interceptors.response.use(
    res => {
        if (res.data) {
            if (res.data.token && res.data.token.length) {
                sessionStorage.setItem("token", res.data.token);
            }
            switch (res.data.error_code) {
                case "-1":
                    // Message.warning({
                    //     showClose: true,
                    //     message: '请求超时，请重新登录'
                    // });
                    sessionStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: "/login"
                        });
                    }, 1000);
                    break;
                case "0":
                    return res;
                case "1":
                    if (
                        res.data.error_msg === "token is null" &&
                        res.data.error_msg != "账号密码错误！"
                    ) {
                        // Message.error({
                        //     showClose: true,
                        //     message: res.data.error_msg + '，请重新登录'
                        // });
                        sessionStorage.clear();
                        setTimeout(() => {
                            that.$router.push({
                                path: "/login"
                            });
                        }, 1000);
                    }
                    // if (res.data.error_msg !== 'token is null') {
                    //     Message.error({
                    //         showClose: true,
                    //         message: res.data.error_msg
                    //     });
                    // }
                    // if (!res.data.bus_json) {
                    return res;
                    // }
                    break;
                case "2":
                    // Message.warning({
                    //     showClose: true,
                    //     message: '您没有登录权限，请重新登录确认，正在跳转到登录页面'
                    // });
                    sessionStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: "/login"
                        });
                    }, 1000);
                    break;
                default:
                    //其他默认返回的blob文件流
                    return res;
            }
        }
    },
    error => {
        console.log(error);
    }
);

export default $axios;
